export const ASSIGNMENT_ENABLED = true
